import { ToastContainer } from 'react-toastify';
import { Breadcrumbs } from '../../../Home/Breadcrumb';
import { TablaHabilitacion } from './Table';

export const ListaHabilitacionContratista = () => {
  return (
    <>
      <ToastContainer />
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <Breadcrumbs title="Habilitaciones Contratista" />
            <TablaHabilitacion />
          </div>
        </div>
      </div>
    </>
  );
};
